/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { StaticDataState } from './static-data.state';
import * as staticDataAction from './static-data.actions';
import { withLoading, withData, withError } from 'app/shared/store/utils/loadable-state';

/** Reducer for the Details state. */
export function reducer(state: StaticDataState, action: staticDataAction.All): StaticDataState {
  switch (action.type) {
    // -------------------------------------------------------------------------
    case staticDataAction.LOAD_STATIC_DATA_VALUES:
      return withLoading(state, action.enumType);

    case staticDataAction.LOAD_STATIC_DATA_VALUES_SUCCESS:
      return withData(state, action.enumType, action.namedValues);

    case staticDataAction.LOAD_STATIC_DATA_VALUES_ERROR:
      return withError(state, action.enumType, action.errorMessage);
  }
  return state;
}
